import type { ReactElement } from "react";

import type { BasicDurations } from "app/services/DurationService";
import { SEGMENT_TYPES } from "app/services/segments/segmentsApiService";
import type { ICustomSegmentAvailableMembers } from "app/services/segments/SegmentsUtils";
import type { ValueOf } from "pro-features/types";
import type { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export interface IBenchmarkVertical {
    title: string;
    tooltipInfo: string;
    dataKey: string;
    filter: any;
    name: string;
    metricLabel: string;
    yAxisFilter?: any;
    index?: number;
    invertChange?: boolean;
    supportedWebSources?: Array<ValueOf<typeof devicesTypes>>;
    chartTooltipTitle?: {
        Daily: string;
        Weekly: string;
        Monthly: string;
    };
    displayCustomAnnotation?: boolean;
    unsupportedDurations?: Array<ValueOf<typeof BasicDurations>>;
}

export interface IBenchmarkVerticals {
    [key: string]: IBenchmarkVertical;
}

export interface IBenchmarkOvertimeProps {
    title: string;
    titleTooltip: string;
    filters: any;
    data: any;
    selectedRows?: any[];
    isLoading?: boolean;
    renderChart?: (selectedTab: FixmeType, filteredChartData: FixmeType, selectedRows: FixmeType) => ReactElement;
    renderLegend?: (selectedChartData: FixmeType, selectedTab: FixmeType) => ReactElement;
    onGraphDDClick: (props: FixmeType) => void;
    tableExcelLink?: string;
    selectedGranularity?: string;
    rowSelectionProp: string;
    availableMembers: ICustomSegmentAvailableMembers;
    SwitcherComponent: any;
    setSelectedTab: any;
}

export interface IBenchmarkOvertimeState {
    selectedTabIndex: number;
}

export const segmentTypesDisabledVerticals: Partial<Record<SEGMENT_TYPES, string[]>> = {
    [SEGMENT_TYPES.WEBSITE]: ["TrafficShare"],
};
